import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Tag,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";

const fields = {
  email: "Email",

  user_type: "Which of the following best describes you?",
  age_group: "Which age group do you belong to?",
  preferred_pack: "Which pack do you prefer?",
  preference_reason: "Why do you prefer this pack?",
  first_impression: "What is the first thing you notice about the new pack?",
  premium_pack: "Which pack looks premium?",
  purchase_likelihood:
    "If the new packaging is priced 10% higher than the current pack, how likely are you to buy it?",
  recommendation_likelihood:
    "How likely are you to recommend this pack to friends or family?",

  voucher_code: {
    header: "Coupon Code",
    formatter: (_value, record) => {
      if (record.has_voucher && record.voucher_code) {
        return record.voucher_code;
      }
      return "NA";
    },
  },

  is_duplicate: {
    header: "Is this Duplicate Entry?",
    formatter: (_value, record) => (record.is_duplicate ? "Yes" : "No"),
  },

  createdAt: {
    header: "Created At",
    formatter: (_value, record) => helper.ISTDate(record.createdAt),
  },
};

function PackagingSurvey() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const moduleNamePural = "Laxmi Packaging Survey 2026";
  const base_url = config.api_url + "admin/leads/packaging-survey";

  // 🔍 View Detail
  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      setdraweropen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  // 📡 Fetch Data
  const fetchDatas = async () => {
    setloading(true);
    const res = await http.get(base_url);

    if (res) {
      const formatted = res.data.map((item) => ({
        ...item,
        duplicate_text: item.is_duplicate ? "Yes" : "No",
      }));

      setDatas(formatted);
    }

    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  // 📊 Table Columns
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Coupon Code",
      dataIndex: "voucher_code",
      key: "voucher_code",
      render: (_, record) => {
        if (record.has_voucher && record.voucher_code) {
          return <Tag color="green">{record.voucher_code}</Tag>;
        }

        return "NA";
      },
    },
    {
      title: "Is this Duplicate Entry?",
      dataIndex: "duplicate_text",
      key: "duplicate_text",
      render: (_, record) => (record.is_duplicate ? "Yes" : "No"),
    },
    {
      title: "Created At",
      render: (_, record) => helper.ISTDate(record.createdAt),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleView(record._id)}>View Detail</Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <Card title={moduleNamePural}>
            <Table
              rowKey={(record) => record._id}
              columns={columns}
              dataSource={datas}
              loading={loading}
              searchable
              pagination={{
                ...pagination,
                total: datas.length,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                onChange: (page, pageSize) => {
                  setPagination({
                    current: page,
                    pageSize: pageSize,
                  });
                },
              }}
              exportableProps={{
                showColumnPicker: true,
                fields,
                fileName: moduleNamePural,
              }}
            />
          </Card>

          {/* 📂 Drawer */}
          <Drawer
            title="Survey Details"
            placement="right"
            onClose={handleDrawerClose}
            visible={drawerOpen}
            size="large"
          >
            {data && (
              <Descriptions
                bordered
                column={1}
                labelStyle={{ width: "55%" }} // 👈 LESS space for question
                contentStyle={{ width: "45%" }} // 👈 MORE space for answer
              >
                <Descriptions.Item label="Email id">
                  {data.email || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Which of the following best describes you?">
                  {data.user_type || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Which age group do you belong to?">
                  {data.age_group || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Which pack do you prefer?">
                  {data.preferred_pack || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Why do you prefer this pack?">
                  {data.preference_reason || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="What is the first thing you notice about the new pack?">
                  {data.first_impression || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Which pack looks premium?">
                  {data.premium_pack || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="If the new packaging is priced 10% higher than the current pack, how likely are you to buy it?">
                  {data.purchase_likelihood || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="How likely are you to recommend this pack to friends or family?">
                  {data.recommendation_likelihood || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Coupon Code">
                  {data.has_voucher && data.voucher_code ? (
                    <Tag color="green">{data.voucher_code}</Tag>
                  ) : (
                    "NA"
                  )}
                </Descriptions.Item>

                <Descriptions.Item label="Is this Duplicate Entry?">
                  {data.is_duplicate ? "Yes" : "No"}
                </Descriptions.Item>

                <Descriptions.Item label="Created At">
                  {helper.ISTDate(data.createdAt)}
                </Descriptions.Item>
              </Descriptions>
            )}
          </Drawer>
        </Col>
      </Row>
    </div>
  );
}

export default PackagingSurvey;
